export const AUTH_ERROR = 1;
export const NO_USER_DATA = 2;
export const SUCCESS = 0;
